export default function getResource(label, vars = []) {
    const resources = {
        email: 'Adresse courriel',
        edit: 'Modifier',
        confirmEmailLabel: 'Confirmer l’adresse courriel',
        cancel: 'Annuler',
        update: 'Mise à jour',
        emptyEmailMessage: 'Veuillez remplir ce champ.',
        invalidConfirmationMessage: 'L’adresse courriel saisie ne correspond pas. Veuillez corriger pour continuer.',
        invalidEmailMessage: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
        invalidEmailError: 'Type d’adresse courriel non valide. Veuillez entrer une adresse courriel valide',
        warningTextTitle: 'Êtes-vous sûr(e)?',
        warningPasskeyText1: 'La modification de votre adresse courriel supprimera également toutes les clés d’accès associées à votre compte Sephora.',
        warningPasskeyText2: 'Après la modification, vous pourrez facilement configurer de nouvelles clés d’accès pour vous connecter de manière rapide et efficace.',
        warningPasskeyText3: 'Voulez-vous poursuivre?',
        continue: 'Continuer'
    };
    return resources[label];
}
